import React, { useState, useEffect } from 'react'
import { Typography, message, Tooltip } from 'antd'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { useSelector } from 'react-redux'
import Overview from './Partials/Overview'
import Communication from './Partials/Communication'
import Aptitude from './Partials/Aptitude'
import CommunicationInstructions from '../Partials/Communicationassmt/instruction'
import { LockOutlined } from '@ant-design/icons'
// Updated import to use main actions
import {
  checkPracticeAccess,
  fetchPracticeScores,
  fetchAssessmentQuestions,
  saveQuestionResponse,
  fetchCompletedPracticeAssessments,
} from '../actions'
import { trackPracticeLockedClicked, trackPracticeTabViewed } from '../../../utils/assessmentEvents'

const { Title } = Typography

const breakpoints = {
  mobile: '320px',
  tablet: '768px',
  laptop: '1024px',
}

const ReportContainer = styled.div`
  width: 100%;
  margin: 24px auto;
  padding: 0 120px;

  @media only screen and (min-width: 1200px) and (max-width: 1300px) {
    padding: 0 20px;
  }

  @media only screen and (min-width: 768px) and (max-width: 1200px) {
    padding: 0;
  }

  @media only screen and (max-device-width: 767px) {
    padding: 0;
  }
`

const HeaderSection = styled.div`
  width: 100%;
  height: 134px;
  background: #f7f7f7;
  border-radius: 25px;
  display: flex;
  align-items: left;
  position: relative;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 32px;
  margin-top: 64px;

  @media (max-width: ${breakpoints.tablet}) {
    height: auto;
    padding: 24px 16px;
    border-radius: 16px;
  }

  @media (max-width: ${breakpoints.mobile}) {
    padding: 16px;
    margin-bottom: 24px;
  }
`

const IconSection = styled.div`
  position: absolute;
  left: 70px;
  bottom: 0;
  width: 130px;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: flex-end;

  @media (max-width: ${breakpoints.tablet}) {
    display: none;
  }

  svg {
    width: 100%;
    height: auto;
  }
`

const ContentSection = styled.div`
  margin-left: 276px;
  flex: 1;
  padding: 24px 24px 24px 0;

  @media (max-width: ${breakpoints.tablet}) {
    margin-left: 0;
    padding: 0;
  }
`

const PageTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: #343e59;
  margin: 0 0 12px 0;
  font-family: 'Plus Jakarta Sans', sans-serif;

  @media (max-width: ${breakpoints.tablet}) {
    font-size: 20px;
  }

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 18px;
  }
`

const Description = styled.p`
  font-size: 16px;
  color: #666666;
  margin: 0;
  line-height: 1.5;
  font-weight: 400;
  font-family: 'Plus Jakarta Sans', sans-serif;
  max-width: 800px;

  @media (max-width: ${breakpoints.tablet}) {
    font-size: 14px;
  }
`

const ContentCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
  padding: 32px;
  margin-top: 16px;
  border: 1px solid #f0f0f0;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }

  @media (max-width: ${breakpoints.tablet}) {
    padding: 20px 16px;
  }
`

const TabsContainer = styled.div`
  display: flex;
  margin: 0 0 24px 0;
  border-bottom: 1px solid #f0f0f0;
  padding: 0 0 8px 0;
  overflow-x: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
`

const Tab = styled.div`
  padding: 12px 24px;
  margin-right: 8px;
  cursor: pointer;
  border-bottom: 2px solid
    ${props => (props.active ? '#1890ff' : 'transparent')};
  color: ${props => (props.active ? '#1890ff' : '#595959')};
  font-weight: ${props => (props.active ? '600' : '500')};
  transition: all 0.2s ease;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 15px;
  white-space: nowrap;
  position: relative;

  &:hover {
    color: #1890ff;
    background: rgba(24, 144, 255, 0.04);
    border-radius: 4px 4px 0 0;
  }

  &:active {
    transform: translateY(1px);
  }

  @media (max-width: ${breakpoints.tablet}) {
    padding: 10px 16px;
    font-size: 14px;
  }
`

const ContentContainer = styled.div`
  padding: 0 0 16px 0;
  display: block;
  animation: fadeIn 0.3s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  & > * {
    animation: slideUp 0.3s ease;
  }

  @keyframes slideUp {
    from {
      transform: translateY(10px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`

const AccessDeniedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  background: #fafafa;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
`

const AccessDeniedIcon = styled.div`
  font-size: 64px;
  color: #ff4d4f;
  margin-bottom: 24px;
`

const AccessDeniedTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 12px;
  font-family: 'Plus Jakarta Sans', sans-serif;
`

const AccessDeniedMessage = styled.p`
  font-size: 16px;
  color: #595959;
  margin: 0;
  line-height: 1.5;
  max-width: 400px;
  font-family: 'Plus Jakarta Sans', sans-serif;
`

const LockIcon = styled(LockOutlined)`
  margin-left: 6px;
  font-size: 14px;
  color: #000000;
  animation: pulse 2s infinite;

  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.6;
    }
    100% {
      opacity: 1;
    }
  }
`

const PlacementPrep = ({
  checkPracticeAccess,
  hasPracticeAccess,
  practiceAccessLoading,
  practiceAccessError, // Add this prop
  auth,
  fetchAssessmentQuestions,
  saveQuestionResponse,
  fetchPracticeScores,
  practiceScores,
  practiceScoresLoading,
}) => {
  const [activeTab, setActiveTab] = useState('overview')
  const [assignedAssessment, setAssignedAssessment] = useState(null)

  // Add useSelector to get practice access state
  const practiceAccessState = useSelector(
    state => state.assessment?.practiceAccess
  )
  const hasPracticeAccessFromSelector = practiceAccessState?.hasAccess || false
  const practiceAccessLoadingFromSelector =
    practiceAccessState?.loading || false

  console.log('🔍 Practice Access State:', {
    practiceAccessState,
    hasPracticeAccessFromSelector,
    practiceAccessLoadingFromSelector,
    hasPracticeAccessFromProps: hasPracticeAccess,
  })

  useEffect(() => {
    checkPracticeAccess()
  }, [checkPracticeAccess, fetchPracticeScores, auth])
  
  const handleTabClick = tab => {
    console.log(
      'Tab clicked:',
      tab,
      'Practice access state:',
      practiceAccessState
    )
    
    // Check if trying to access communication tab without practice access
    if (
      tab === 'communication' &&
      !practiceAccessState?.Communication?.hasAccess
    ) {
      console.log('Practice access denied for communication tab')
      trackPracticeTabViewed(practiceAccessState?.Communication?.completedCount === 2, practiceAccessState?.Communication?.completedCount, "communication")
      trackPracticeLockedClicked(practiceAccessState?.Communication?.completedCount, "communication");
      // const completedCount = practiceAccessState?.Communication?.completedCount || 0;
      // const remainingCount = 2 - completedCount;

      // let messageText;
      // if (completedCount === 0) {
      //   messageText = "You need to complete two Communication assessments to access Communication practice";
      // } else if (completedCount === 1) {
      //   messageText = "Almost there! Complete one more Communication assessment to unlock practice mode";
      // }

      // message.error({
      //   content: messageText,
      //   duration: 4,
      //   style: {
      //     marginTop: '20vh',
      //   },
      // });

      return
    }

    // Check if trying to access aptitude tab without practice access
    if (tab === 'aptitude' && !practiceAccessState?.Aptitude?.hasAccess) {
      console.log('Practice access denied for aptitude tab')
      trackPracticeTabViewed(practiceAccessState?.Aptitude?.completedCount === 2, practiceAccessState?.Aptitude?.completedCount, "aptitude")
      trackPracticeLockedClicked(practiceAccessState?.Aptitude?.completedCount, "aptitude");
      // const completedCount = practiceAccessState?.Aptitude?.completedCount || 0;
      // const remainingCount = 2 - completedCount;

      // let messageText;
      // if (completedCount === 0) {
      //   messageText = "You need to complete two Aptitude assessments to access Aptitude practice";
      // } else if (completedCount === 1) {
      //   messageText = "Great progress! One more Aptitude assessment needed to unlock practice mode";
      // }

      // message.error({
      //   content: messageText,
      //   duration: 4,
      //   style: {
      //     marginTop: '20vh',
      //   },
      // });

      return
    }

    console.log('Tab access granted, switching to:', tab)
    setActiveTab(tab)
  }

  const handleAssessmentAssigned = assessment => {
    setAssignedAssessment(assessment)
    setActiveTab('communication') // Switch to communication tab when assessment is assigned
  }

  const handleAssessmentComplete = () => {
    setAssignedAssessment(null)
  }

  const handleBackFromAssessment = () => {
    setAssignedAssessment(null)
  }

  // Component to render when practice access is denied
  const renderAccessDenied = type => (
    <AccessDeniedContainer>
      <AccessDeniedTitle>Practice Access Required</AccessDeniedTitle>
      <AccessDeniedMessage>
        {practiceAccessState?.[type]?.reason ||
          `${type} practice is not enabled for your institute.`}{' '}
        Please contact your placement office.
      </AccessDeniedMessage>
    </AccessDeniedContainer>
  )

  // If there's an assigned assessment, show it in the main area without tabs
  if (assignedAssessment) {
    return (
      <ReportContainer>
        <ContentCard>
          <CommunicationInstructions
            assessment={assignedAssessment}
            onBack={handleBackFromAssessment}
            onComplete={handleAssessmentComplete}
            isPractice={true}
            fetchAssessmentQuestions={id => {
              return fetchAssessmentQuestions(id)
            }}
            saveQuestionResponse={(
              questionId,
              answer,
              assessment_assigned_id,
              subQuestionId,
              questionType
            ) =>
              saveQuestionResponse(
                questionId,
                answer,
                assessment_assigned_id,
                subQuestionId,
                questionType
              )
            }
            setAssessment={setAssignedAssessment}
            questions={[]}
            totalQuestions={0}
            loading={false}
            error={null}
            responses={{}}
            enableFullscreen={false}
            autoStart={false}
            disableProctoring={true}
          />
        </ContentCard>
      </ReportContainer>
    )
  }

  return (
    <ReportContainer>
      <ContentCard>
        <TabsContainer>
          <Tab
            active={activeTab === 'overview'}
            onClick={() => handleTabClick('overview')}
            locked={false}
          >
            Overview
          </Tab>

          <Tooltip
            title={
              !practiceAccessState?.Communication?.hasAccess
                ? practiceAccessState?.Communication?.reason
                : ''
            }
            placement="top"
          >
            <Tab
              active={activeTab === 'communication'}
              onClick={() => handleTabClick('communication')}
              locked={!practiceAccessState?.Communication?.hasAccess}
            >
              Communication
              {!practiceAccessState?.Communication?.hasAccess && <LockIcon />}
            </Tab>
          </Tooltip>

          <Tooltip
            title={
              !practiceAccessState?.Aptitude?.hasAccess
                ? practiceAccessState?.Aptitude?.reason
                : ''
            }
            placement="top"
          >
            <Tab
              active={activeTab === 'aptitude'}
              onClick={() => handleTabClick('aptitude')}
              locked={!practiceAccessState?.Aptitude?.hasAccess}
            >
              Aptitude
              {!practiceAccessState?.Aptitude?.hasAccess && <LockIcon />}
            </Tab>
          </Tooltip>
        </TabsContainer>

        <ContentContainer>
          {activeTab === 'overview' && <Overview />}
          {activeTab === 'communication' &&
            // Show Communication component only if user has practice access
            (practiceAccessState?.Communication?.hasAccess ? (
              <Communication
                auth={auth}
                onAssessmentAssigned={handleAssessmentAssigned}
                assignedAssessment={assignedAssessment}
              />
            ) : (
              renderAccessDenied('Communication')
            ))}
          {activeTab === 'aptitude' &&
            // Add same access control as Communication
            (practiceAccessState?.Aptitude?.hasAccess ? (
              <Aptitude
                auth={auth}
                onAssessmentAssigned={handleAssessmentAssigned}
                assignedAssessment={assignedAssessment}
              />
            ) : (
              renderAccessDenied('Aptitude')
            ))}
        </ContentContainer>
      </ContentCard>
    </ReportContainer>
  )
}

const mapStateToProps = state => {
  console.log('🔍 Redux State Mapping:', {
    fullState: state,
    assessmentState: state.assessment,
    practiceAccess: state.assessment?.practiceAccess,
  })

  return {
    auth: state.auth,
    hasPracticeAccess: state.assessment?.practiceAccess?.hasAccess || false,
    practiceAccessLoading: state.assessment?.practiceAccess?.loading || false,
    practiceAccessError: state.assessment?.practiceAccess?.error || null,
    practiceScores: state.assessment?.practiceScores?.data || [],
    practiceScoresLoading: state.assessment?.practiceScores?.loading || false,
    practiceScoresError: state.assessment?.practiceScores?.error || null,
  }
}

const mapDispatchToProps = {
  checkPracticeAccess,
  fetchAssessmentQuestions,
  saveQuestionResponse,
  fetchPracticeScores,
  fetchCompletedPracticeAssessments,
}

export default connect(mapStateToProps, mapDispatchToProps)(PlacementPrep)
